(() => {
  if (customElements.get('selecao-editorial')) {
    return;
  }

  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  class SelecaoEditorial extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.sliderEl = null;
      this.enableMobile = false;
      this.enableDesktop = false;
      this.controls = [];
      this.prevArrow = null;
      this.nextArrow = null;
      this._onMediaChange = this.updateSlider.bind(this);
      this._onControlClick = this.onControlClick.bind(this);
      this._onSliderMove = this.updateArrows.bind(this);
    }

    connectedCallback() {
      this.sliderEl = this.querySelector('[data-slider]');
      if (!this.sliderEl) {
        return;
      }

      this.enableMobile = this.dataset.carouselMobile === 'true';
      this.enableDesktop = this.dataset.carouselDesktop === 'true';
      this.prevArrow = this.querySelector('[data-prev]');
      this.nextArrow = this.querySelector('[data-next]');
      this.controls = this.querySelectorAll('[data-control]');
      this.controls.forEach((control) => {
        control.addEventListener('click', this._onControlClick);
      });

      if (!this.enableMobile && !this.enableDesktop) {
        return;
      }

      if (typeof DESKTOP_MQ.addEventListener === 'function') {
        DESKTOP_MQ.addEventListener('change', this._onMediaChange);
      } else {
        DESKTOP_MQ.addListener(this._onMediaChange);
      }

      this.updateSlider();
    }

    disconnectedCallback() {
      if (typeof DESKTOP_MQ.removeEventListener === 'function') {
        DESKTOP_MQ.removeEventListener('change', this._onMediaChange);
      } else {
        DESKTOP_MQ.removeListener(this._onMediaChange);
      }
      this.controls.forEach((control) => {
        control.removeEventListener('click', this._onControlClick);
      });
      this.destroySlider();
    }

    onControlClick(event) {
      event.preventDefault();

      if (!this.slider) {
        return;
      }

      const control = event.currentTarget;
      const action = control.hasAttribute('data-prev') ? '<' : '>';

      this.slider.go(action);
    }

    updateArrows(_newIndex, _prevIndex, destIndex) {
      if (!this.slider || !this.prevArrow || !this.nextArrow) {
        return;
      }

      const endIndex = this.slider.Components.Controller.getEnd();
      const atStart = destIndex <= 0;
      const atEnd = destIndex >= endIndex;

      this.prevArrow.classList.toggle('hidden', atStart);
      this.nextArrow.classList.toggle('hidden', atEnd);
    }

    shouldRunCarousel() {
      const isDesktop = DESKTOP_MQ.matches;

      if (this.enableMobile && this.enableDesktop) {
        return true;
      }

      if (this.enableMobile && !isDesktop) {
        return true;
      }

      if (this.enableDesktop && isDesktop) {
        return true;
      }

      return false;
    }

    getSliderOptions() {
      const gapMobile = `${this.dataset.gapMobile || 24}px`;
      const gapDesktop = `${this.dataset.gapDesktop || 40}px`;
      const perPageMobile = parseFloat(this.dataset.perPageMobile);
      const perPageDesktop = parseFloat(this.dataset.perPageDesktop);
      const mobileSlides = Number.isFinite(perPageMobile) ? perPageMobile : 1.2;
      const desktopSlides = Number.isFinite(perPageDesktop) ? perPageDesktop : 4;
      const mobilePeek = mobileSlides > 0 && mobileSlides < 2;

      const mobileBreakpoint = {
        gap: gapMobile,
        perMove: 1
      };

      if (mobilePeek) {
        mobileBreakpoint.perPage = 1;
        mobileBreakpoint.fixedWidth = `calc(100% / ${mobileSlides})`;
      } else {
        mobileBreakpoint.perPage = mobileSlides;
      }

      return {
        type: 'slide',
        pagination: false,
        arrows: false,
        rewind: false,
        drag: true,
        perMove: 1,
        trimSpace: true,
        gap: gapDesktop,
        perPage: desktopSlides,
        autoHeight: true,
        breakpoints: {
          989: mobileBreakpoint
        }
      };
    }

    mountSlider() {
      this.destroySlider();

      this.slider = new Splide(this.sliderEl, this.getSliderOptions()).mount();
      this.sliderEl.classList.add('selecao-editorial--carousel-active');
      this.slider.on('move', this._onSliderMove);
      this.updateArrows(0, 0, this.slider.index);
    }

    destroySlider() {
      if (!this.slider) {
        this.cleanupSliderClasses();
        return;
      }

      this.slider.off('move', this._onSliderMove);
      this.slider.destroy(true);
      this.slider = null;
      this.cleanupSliderClasses();
    }

    cleanupSliderClasses() {
      if (!this.sliderEl) {
        return;
      }

      this.sliderEl.classList.remove(
        'selecao-editorial--carousel-active',
        'is-initialized',
        'is-active',
        'is-destroyed'
      );
    }

    updateSlider() {
      if (!this.sliderEl) {
        return;
      }

      const shouldCarousel = this.shouldRunCarousel();

      if (shouldCarousel) {
        if (!this.slider) {
          this.mountSlider();
          return;
        }

        this.slider.destroy(true);
        this.slider = null;
        this.mountSlider();
      } else {
        this.destroySlider();
      }
    }
  }

  customElements.define('selecao-editorial', SelecaoEditorial);
})();
